import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import env from '../misc/env';
import DataLoader from 'dataloader';
import { createIamAPI } from './API';
import Team from './Team';
import * as path from 'path';
import { action } from 'mobx';

/**
 * Team Store.
 */
var TeamStore = /*#__PURE__*/function (_Store) {
  function TeamStore() {
    var _this;
    _classCallCheck(this, TeamStore);
    _this = _callSuper(this, TeamStore, arguments);
    /**
     * Teams collection.
     */
    _this.teams = _this.collection({
      model: Team
    });
    /**
     * IAM API.
     */
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    /**
     * Cache key function used for data loader.
     */
    _this.cacheKeyFn = function (id) {
      return "".concat(id.workspace_id, "/").concat(id.team_id);
    };
    /**
     * Cache map.
     */
    _this.teamCacheMap = new Map();
    /**
     * Data loader.
     */
    _this.teamLoader = new DataLoader(_this._fetchMany.bind(_this), {
      cacheKeyFn: _this.cacheKeyFn,
      cacheMap: _this.teamCacheMap
    });
    _this.rootStore.sessionStore.onWorkspaceSelected(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.teams.clear();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return _this;
  }
  _inherits(TeamStore, _Store);
  return _createClass(TeamStore, [{
    key: "fetchTeam",
    value: (
    /**
     * Fetches a team by ID.
     *
     * @param {*} id
     */
    function () {
      var _fetchTeam = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.teamLoader.load(makeIdParams(id)));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchTeam(_x) {
        return _fetchTeam.apply(this, arguments);
      }
      return fetchTeam;
    }()
    /**
     * Fetches many teams.
     *
     * @param {*} ids
     */
    )
  }, {
    key: "fetchManyTeams",
    value: (function () {
      var _fetchManyTeams = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ids) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.teamLoader.loadMany(ids.map(makeIdParams)));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchManyTeams(_x2) {
        return _fetchManyTeams.apply(this, arguments);
      }
      return fetchManyTeams;
    }()
    /**
     * Queries for teams.
     *
     * @param {*} params
     */
    )
  }, {
    key: "findTeams",
    value: (function () {
      var _findTeams = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        var _yield$this$api$teams, data, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.api.teams.find(params);
            case 2:
              _yield$this$api$teams = _context4.sent;
              data = _yield$this$api$teams.data;
              result = _objectWithoutProperties(_yield$this$api$teams, _excluded);
              return _context4.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
                data: this.teams.set(data)
              }));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function findTeams(_x3) {
        return _findTeams.apply(this, arguments);
      }
      return findTeams;
    }()
    /**
     * Creates a team.
     *
     * @param {*} payload
     */
    )
  }, {
    key: "createTeam",
    value: (function () {
      var _createTeam = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.api.teams.create(payload).then(this.teams.set));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createTeam(_x4) {
        return _createTeam.apply(this, arguments);
      }
      return createTeam;
    }()
    /**
     * Creates a team.
     *
     * @param {*} payload
     */
    )
  }, {
    key: "updateTeam",
    value: (function () {
      var _updateTeam = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, payload) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.api.teams.update(id, payload).then(this.teams.set));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateTeam(_x5, _x6) {
        return _updateTeam.apply(this, arguments);
      }
      return updateTeam;
    }()
    /**
     * Implementation of fetching many teams.
     *
     * @param {*} ids
     */
    )
  }, {
    key: "_fetchMany",
    value: (function () {
      var _fetchMany2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ids) {
        var _this2 = this;
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.api.teams.getMany(ids).then(this.teams.set);
            case 2:
              result = _context7.sent;
              result.forEach(function (t, i) {
                if (!t) {
                  // Just because a team was not found does not mean it will never exist.
                  _this2.teamLoader.clear(ids[i]);
                }
              });
              return _context7.abrupt("return", result);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function _fetchMany(_x7) {
        return _fetchMany2.apply(this, arguments);
      }
      return _fetchMany;
    }()
    /**
     * Uploads a new avatar for the team.
     *
     * @param {*} file
     */
    )
  }, {
    key: "changeAvatar",
    value: (function () {
      var _changeAvatar = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(team_id, file) {
        var maxSize, ext, isSupported, msg;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              maxSize = 1024 * 1024 * 10;
              ext = path.extname(file.name);
              isSupported = /(jpe?g|png)/i.test(ext);
              if (isSupported) {
                _context8.next = 6;
                break;
              }
              this.rootStore.flashMessageStore.create({
                type: 'error',
                message: 'We only support PNG, JPEG and JPG files for profile pictures.'
              }).autoDismiss();
              return _context8.abrupt("return");
            case 6:
              if (!(maxSize < file.size)) {
                _context8.next = 9;
                break;
              }
              this.rootStore.flashMessageStore.create({
                type: 'error',
                message: "Max image size is 10mb."
              }).autoDismiss();
              return _context8.abrupt("return");
            case 9:
              msg = this.rootStore.flashMessageStore.create({
                inProgress: true,
                message: 'Uploading new profile picture...'
              });
              _context8.next = 12;
              return this.api.teams.changeAvatar(team_id, file).then(action(this.teams.set)).then(action(function () {
                msg.done('Successfully changed profile picture!').autoDismiss();
              })).catch(action(function (err) {
                msg.failed(err.message);
                console.error(err);
              }));
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function changeAvatar(_x8, _x9) {
        return _changeAvatar.apply(this, arguments);
      }
      return changeAvatar;
    }())
  }]);
}(Store);
/**
 * Makes a single ID into an object-style.
 * @param {*} id
 */
export { TeamStore as default };
function makeIdParams(id) {
  return typeof id === 'string' ? {
    id: id,
    workspace_id: null
  } : id;
}
//# sourceMappingURL=TeamStore.js.map
